import React from 'react'
import styles from './style.module.scss'
import { Row } from 'react-bootstrap'
import PropTypes from 'prop-types'
import MyImage from '@shared/components/myImage'
import CustomLink from '@shared/components/customLink'
import { getImgURL } from '@shared-submodule/utils'
function ChessPlayers({ data, isHockey = false, isChampions = false, isWPL = false, captains, isMobile = false }) {
  if (isHockey) {
    return (
      <div className={`container ${styles.highlight} px-0`}>
        <div className="widget-title  d-flex justify-content-between align-items-center">
          <h3 className="small-head d-flex align-items-center  mb-0">
            <span>{isHockey ? 'Star Players' : 'Players'}</span>
          </h3>
        </div>
        <Row className="flex-nowrap scroll-list pb-4 d-flex gap-4">
          {data?.map((d, i) => {
            if (d?.articleSlug) {
              return (
                <CustomLink key={i} href={`/${d?.articleSlug}`}>
                  <div className={`d-flex cursor-pointer ${styles.playerCard}`}>
                    <div>
                      <MyImage className={styles.playerImage} src={d?.logo} height={115} width={115} />
                    </div>
                    <h3 className={styles.truncatedText}>{d.name}</h3>
                    <p>{d?.teamData?.teamName}</p>
                    <div className={styles.teamImg}>
                      <MyImage src={d?.countryFlag} height={50} width={50} />
                    </div>
                  </div>
                </CustomLink>
              )
            } else {
              return (
                <div className={`d-flex ${styles.playerCard}`} key={i}>
                  <div>
                    <MyImage className={styles.playerImage} src={d?.logo} height={115} width={115} />
                  </div>
                  <h3 className={styles.truncatedText}>{d.name}</h3>
                  <p>{d?.teamData?.teamName}</p>
                  <div className={styles.teamImg}>
                    <MyImage src={d?.countryFlag} height={50} width={50} />
                  </div>
                </div>
              )
            }
          })}
        </Row>
      </div>
    )
  } else if (isChampions || isWPL) {
    return (
      <>
        <div className={`container ${styles.highlight} px-0`}>
          <div className="widget-title  d-flex justify-content-between align-items-center">
            <h3 className="small-head d-flex align-items-center  mb-0">
              <span>{(isChampions || isWPL) && 'Captains'}</span>
            </h3>
          </div>
          <Row className="flex-nowrap scroll-list pb-4 d-flex gap-4">
            {captains?.map((captain, i) => {
              if (captain?.oSeo?.sSlug && !isMobile) {
                return (
                  <CustomLink key={i} href={`/${captain?.oSeo?.sSlug}`}>
                    <div className={`d-flex cursor-pointer ${styles.playerCard}`}>
                      <div>
                        <MyImage
                          className={styles.playerImage}
                          alt={captain.sFullName || 'Player Image'}
                          src={getImgURL(captain.oImg?.sUrl)}
                          height={115}
                          width={115}
                        />
                      </div>
                      <h3 className={styles.truncatedText}>{captain.sFullName || ''}</h3>
                      <p>{isChampions ? captain?.sCountryFull : captain?.oTeam?.sAbbr || ''}</p>
                      <div className={`${styles.teamImg}`}>
                        <MyImage alt={captain?.sCountry || 'Country Flag'} src={getImgURL(captain.oFlag?.sUrl)} height={50} width={50} />
                      </div>
                    </div>
                  </CustomLink>
                )
              } else {
                return (
                  <div className={`d-flex cursor-pointer ${styles.playerCard}`} key={i}>
                    <div>
                      <MyImage
                        className={styles.playerImage}
                        alt={captain.sFullName || 'Player Image'}
                        src={getImgURL(captain.oImg?.sUrl)}
                        height={115}
                        width={115}
                      />
                    </div>
                    <h3 className={styles.truncatedText}>{captain.sFullName || ''}</h3>
                    <p>{isChampions ? captain?.sCountryFull : captain?.oTeam?.sAbbr || ''}</p>
                    <div className={`${styles.teamImg}`}>
                      <MyImage alt={captain?.sCountry || 'Country Flag'} src={getImgURL(captain.oFlag?.sUrl)} height={50} width={50} />
                    </div>
                  </div>
                )
              }
            })}
          </Row>
        </div>
      </>
    )
  } else {
    return (
      <div className={`container ${styles.highlight} px-0`}>
        <div className="widget-title  d-flex justify-content-between align-items-center">
          <h3 className="small-head d-flex align-items-center  mb-0">
            <span>{isHockey ? 'Captains' : 'Players'}</span>
          </h3>
        </div>
        <Row className="flex-nowrap scroll-list pb-4 d-flex gap-4">
          {data?.data?.map((d, i) =>
            d?.sArticleUrl ? (
              <CustomLink key={i} href={d.sArticleUrl}>
                <div className={`d-flex cursor-pointer ${styles.playerCard}`}>
                  <div>
                    <MyImage
                      className={styles.playerImage}
                      alt={d.sFullName || 'Player Image'}
                      src={d.oImg?.sUrl}
                      height={115}
                      width={115}
                    />
                  </div>
                  <h3 className={styles.truncatedText}>{d.sFullName}</h3>
                  <p>{d.oTeam?.sTitle}</p>
                  <div className={styles.teamImg}>
                    <MyImage alt={d.oTeam?.sTitle || 'Team Logo'} src={d.oTeam?.oImg?.sUrl} height={50} width={50} />
                  </div>
                </div>
              </CustomLink>
            ) : (
              <div key={i} className={`d-flex ${styles.playerCard}`}>
                <div>
                  <MyImage alt={d.sFullName || 'Player Image'} className={styles.playerImage} src={d.oImg?.sUrl} height={115} width={115} />
                </div>
                <h3 className={styles.truncatedText}>{d.sFullName}</h3>
                <p>{d.oTeam?.sTitle}</p>
                <div className={styles.teamImg}>
                  <MyImage alt={d.oTeam?.sTitle || 'Team Logo'} src={d.oTeam?.oImg?.sUrl} height={50} width={50} />
                </div>
              </div>
            )
          )}
        </Row>
      </div>
    )
  }
}

ChessPlayers.propTypes = {
  data: PropTypes.object,
  captains: PropTypes.array,
  isHockey: PropTypes.bool,
  isChampions: PropTypes.bool,
  isWPL: PropTypes.bool,
  isMobile: PropTypes.bool
}

export default ChessPlayers
